import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { SnackbarContainer } from './useSnackbarContainer';

const useStyles = makeStyles(theme => ({
  success: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
  },
  error: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },
  info: {
    backgroundColor: theme.palette.grey[850],
    color: theme.palette.common.white,
  },
}));

export const AppSnackbar = () => {
  const classes = useStyles();
  const {
    snackbar,
    dismissSnackbar,
    flushPendingCommit,
    cancelUndoable,
  } = SnackbarContainer.useContainer();

  const undoAction = snackbar.undoable ? (
    <Button color="inherit" size="small" onClick={cancelUndoable}>
      UNDO
    </Button>
  ) : undefined;

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={snackbar.duration}
      disableWindowBlurListener={snackbar.undoable}
      onClose={dismissSnackbar}
      onExited={flushPendingCommit}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <SnackbarContent
        className={classes[snackbar.severity]}
        message={snackbar.message}
        action={undoAction}
      />
    </Snackbar>
  );
};
